import {
    FETCH_ROLE_PERMISSIONS_REQUEST,
    FETCH_ROLE_PERMISSIONS_SUCCESS,
    FETCH_ROLE_PERMISSIONS_FAILURE,
    SAVE_ROLE_PERMISSIONS_REQUEST,
    SAVE_ROLE_PERMISSIONS_SUCCESS,
    SAVE_ROLE_PERMISSIONS_FAILURE
  } from '../../../../types/masters/users/rolePermission/rolePermissionTypes';
  
  const initialState = {
    list: [],
    loading: false,
    error: null,
    saveLoading: false,
    saveError: null,
  };
  
  export default function rolePermissionReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_ROLE_PERMISSIONS_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_ROLE_PERMISSIONS_SUCCESS:
        return { ...state, loading: false, list: action.payload };
      case FETCH_ROLE_PERMISSIONS_FAILURE:
        return { ...state, loading: false, error: action.error };
      case SAVE_ROLE_PERMISSIONS_REQUEST:
        return { ...state, saveLoading: true, saveError: null };
      case SAVE_ROLE_PERMISSIONS_SUCCESS:
        return { ...state, saveLoading: false };
      case SAVE_ROLE_PERMISSIONS_FAILURE:
        return { ...state, saveLoading: false, saveError: action.error };
      default:
        return state;
    }
  }